import { render, staticRenderFns } from "./Notificator.vue?vue&type=template&id=a5c03ac0&"
import script from "./Notificator.vue?vue&type=script&lang=ts&"
export * from "./Notificator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5c03ac0')) {
      api.createRecord('a5c03ac0', component.options)
    } else {
      api.reload('a5c03ac0', component.options)
    }
    module.hot.accept("./Notificator.vue?vue&type=template&id=a5c03ac0&", function () {
      api.rerender('a5c03ac0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Notificator.vue"
export default component.exports